import { useRef, createRef, useEffect, useState } from "react";
import ForwardedQuestion from "../../components/question/ForwardedQuestion";
import { useDispatch, useSelector } from "react-redux";
import { requestAddAnswersQuiz } from "../../redux/actions/fowardQuestionActionCreators";
import Stepper from "../../components/quiz/sideBarStepper/SideBarStepper";
import { Box, Button, useMediaQuery } from "@mui/material";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import Tooltip from "@mui/material/Tooltip";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { translate } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import SadAvatar from "../../components/shared/sadAvatar";
// import LanguageSelect from "../LanguageSelect";

const MainQuiz = ({ data, initialPayload, is_completed, initialThreshold }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [stepsData, setStepsData] = useState([]);
  const [payload, setPayload] = useState({});
  // const [forwardedUseCases, setForwardedUseCases] = useState([])
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const myRefs = useRef([]);
  const params = useParams();
  const { pathname } = useLocation();
  const { isAuth } = useSelector((state) => state.user);
  const forwardedUseCases = data?.usecases?.filter((uc) =>
    data.user_usecases.some((f) => f.usecase_id == uc.id),
  );
  const [questions, setQuestions] = useState([
    forwardedUseCases[0]?.questions[0],
  ]);
  const [filtredUseCases, setFiltredUseCases] = useState(forwardedUseCases);
  const [threshold, setThreshold] = useState(0);
  const [thresholdsPayload, setThresholdsPayload] = useState(initialThreshold);
  const [useCasesCompleted, setUseCasesCompleted] = useState([]);

  const { quizId } = useParams();
  const routerForCompletedQuizes = [`/completed_quizzes/${quizId}`];
  const quizDisabed = routerForCompletedQuizes.includes(pathname);

  const isMobile = useMediaQuery("(max-width:900px)");
  const [isOpen, setIsOpen] = useState(false);
  const [progression, setProgression] = useState([]);

  useEffect(() => {
    setPayload(initialPayload);
  }, [initialPayload]);

  if (forwardedUseCases && forwardedUseCases.length) {
    myRefs.current = forwardedUseCases[activeStep].questions.map(
      (element, i) => myRefs.current[i] ?? createRef(),
    );
  }
  useEffect(() => {
    let theProgress = [];

    Object.keys(initialThreshold).map((el) => {
      if (
        Number(initialThreshold[el]) >=
          data?.usecases?.find((item) => item.id === Number(el))?.threshold ||
        data?.usecases
          ?.find((item) => item.id === Number(el))
          ?.questions.map((el) => el.id)
          .every((e) => !!initialPayload[e])
      ) {
        return (theProgress = [...theProgress, Number(el)]);
      }
    });
    setProgression(theProgress);
  }, [initialPayload, initialThreshold]);
  const toggleAside = () => setIsOpen((prevIsOpen) => !prevIsOpen);

  const isXsMobile = useMediaQuery("(max-width:400px)");

  useEffect(() => {
    if (data.id) {
      setStepsData(forwardedUseCases);
    }
  }, [data.id]);

  const scrollToQuestion = (index) => {
    myRefs.current[index].current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handleClickQuestion = (index) => {
    setCurrentQuestion(index);
    scrollToQuestion(index);
  };

  const goToDashbord = () => {
    history.push("/");
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setCurrentQuestion(0);
    scrollToQuestion(0);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setCurrentQuestion(0);
    scrollToQuestion(0);
  };

  const handleChangeStep = (index) => {
    setActiveStep(index);
    setCurrentQuestion(0);
    scrollToQuestion(0);
  };
  useEffect(() => {
    if (
      forwardedUseCases[activeStep]?.questions?.some((el) =>
        Object.keys(payload)?.some((item) => el.id === Number(item)),
      )
    ) {
      setQuestions(
        forwardedUseCases[activeStep]?.questions?.filter((el) =>
          Object.keys(payload).includes(el.id.toString()),
        ),
      );
    } else {
      setQuestions([forwardedUseCases[activeStep]?.questions[0]]);
    }
  }, [activeStep]);

  const handleSubmit = () => {
    const user_answers = Object.fromEntries(
      Object.entries(thresholdsPayload).filter(([key, value]) =>
        forwardedUseCases.some((uc) => uc.id == key),
      ),
    );

    dispatch(
      requestAddAnswersQuiz(
        {
          answers: { questions: payload, usecases: thresholdsPayload },
          identifier: data.identifier,
          isCompleted: false,
          version: data.version,
          quiz_id: data.quiz_id,
          forward_id: params.forwardId,
          user_answers,
          pourcentage: Math.round(
            (progression.length * 100) / data?.usecases.length,
          ),
        },
        history,
      ),
    );
  };

  useEffect(() => {
    setThreshold(thresholdsPayload[forwardedUseCases[activeStep]?.id] || 0);
  }, [activeStep]);

  const handleQuestion = (question, answer, index, weight) => {
    // setPayload({ ...payload, [question.id]: answer });

    // const useCases = [...forwardedUseCases];
    const res = {
      ...payload,
      [question.id]: { choice: answer, weight: weight },
    };

    var nextThreshold = payload[question.id]?.weight
      ? threshold - payload[question.id]?.weight + weight
      : threshold + weight;

    let filterdAll = forwardedUseCases[activeStep].questions.filter(
      (allItem) => question.id < allItem.id,
    );
    filterdAll.map((el) => {
      res[el.id] && (nextThreshold = nextThreshold - res[el.id]?.weight);
      delete res[el.id];
    });
    if (questions.some((el) => el.id > question.id)) {
      setQuestions(questions.filter((el) => el.id <= question.id));
    }
    setPayload(res);
    setThreshold(nextThreshold);

    if (
      index < forwardedUseCases[activeStep].questions.length - 1 &&
      nextThreshold < forwardedUseCases[activeStep].threshold
    ) {
      setQuestions(questions.splice(index + 1));
      const nextElement = forwardedUseCases[activeStep].questions[index + 1];
      setQuestions([...questions, nextElement]);

      setProgression(
        progression.filter(
          (el) =>
            el !==
            data.usecases.find((el) =>
              el.questions.find((item) => item.id === question.id),
            ).id,
        ),
      );
      if (useCasesCompleted.includes(forwardedUseCases[activeStep].id)) {
        setUseCasesCompleted((prev) =>
          prev.filter((el) => el !== forwardedUseCases[activeStep].id),
        );
      }
    } else {
      setFiltredUseCases(
        filtredUseCases.map((el, index) => {
          if (index === activeStep) {
            if (questions.some((el) => el.id > question.id)) {
              return {
                ...el,
                questions: questions.filter((el) => el.id <= question.id),
              };
            } else {
              return { ...el, questions: questions };
            }
          }
          return { ...el };
        }),
      );

      if (!useCasesCompleted.includes(forwardedUseCases[activeStep].id)) {
        setUseCasesCompleted((prev) => [
          ...prev,
          forwardedUseCases[activeStep].id,
        ]);
      }

      if (activeStep !== data.user_usecases.length - 1) {
        // useCases[activeStep].questions = questions;

        handleNext();
      }
      if (
        !progression.includes(
          data.usecases.find((el) =>
            el.questions.find((item) => item.id === question.id),
          ).id,
        )
      ) {
        setProgression([
          ...progression,
          data.usecases.find((el) =>
            el.questions.find((item) => item.id === question.id),
          ).id,
        ]);
      }
    }
    setThresholdsPayload({
      ...thresholdsPayload,
      [forwardedUseCases[activeStep].id]: nextThreshold,
    });
  };

  useEffect(() => {
    if (forwardedUseCases.length !== 0) {
      setCurrentQuestion(questions.length - 1);
      scrollToQuestion(questions.length - 1);
    }
  }, [questions]);

  const { t } = useTranslation();
  return (
    <div
      className={`container-shadow ${isMobile && isOpen ? "aside-open" : ""}`}
      style={{ display: "flex", height: isMobile ? "80vh" : "100vh" }}
    >
      <Stepper
        goToDashbord={() => goToDashbord()}
        quizDecription={data[translate("description")] || t("not_specified")}
        quizTitle={data[translate("title")] || t("not_specified")}
        payload={payload}
        activeStep={activeStep}
        questionNumbers={data?.user_questions?.length}
        steps={stepsData}
        currentQuestion={currentQuestion}
        handleClickQuestion={(index) => handleClickQuestion(index)}
        changeStep={(index) => handleChangeStep(index)}
        isMobile={isMobile}
        isOpen={isOpen}
        toggleAside={toggleAside}
        version={data.version}
        difficultyLevel={data.difficulty_level}
        forwardingQuizz={data?.user_questions}
        isForwardedQuiz={true}
        thresholdsPayload={thresholdsPayload}
      ></Stepper>
      {forwardedUseCases && !!forwardedUseCases.length ? (
        <div style={{ padding: "20px", flexGrow: isMobile ? 1 : "auto" }}>
          {/* <Navbar /> */}
          {isMobile && <FormatListNumberedIcon onClick={toggleAside} />}
          {/* <div
            style={{
              padding: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <LanguageSelect />
            </div>
          </div> */}
          <div
            style={{
              padding: "10px",
              overflow: "auto",
              height: `${
                is_completed ? "calc(100vh - 160px)" : "calc(100vh - 240px)"
              } `,
              width: isMobile ? "100%" : "calc(100vw - 500px)",
            }}
          >
            {/* {forwardedUseCases[activeStep]?.questions?.map((el, i) => ( */}

            {questions?.map((el, i) => (
              <div key={i}>
                <ForwardedQuestion
                  is_completed={is_completed}
                  questionsCount={questions.length}
                  myAnswer={payload?.[el.id]}
                  handleQuestion={(question, answer, index, weight) =>
                    handleQuestion(question, answer, index, weight)
                  }
                  currentQuestion={currentQuestion}
                  questionIndex={i}
                  question={el}
                  key={el.id}
                  ref={myRefs.current[i]}
                  quizDisabed={quizDisabed}
                  userQuestion={questions}
                ></ForwardedQuestion>{" "}
              </div>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              padding: isXsMobile ? 0 : "20px 0px 20px 20px",
              justifyContent: "space-between",
              gap: isXsMobile ? 5 : 0,
            }}
          >
            <Button
              color="secondary"
              onClick={handleBack}
              disabled={!activeStep || activeStep === 0}
              style={{ width: isXsMobile ? "50%" : "190px" }}
              variant="outlined"
            >
              {t("previous")}
            </Button>{" "}
            {(activeStep || activeStep === 0) &&
            activeStep === forwardedUseCases?.length - 1 ? (
              useCasesCompleted.length === forwardedUseCases.length ? (
                <Button
                  onClick={handleSubmit}
                  color="secondary"
                  style={{ width: "190px" }}
                  variant="contained"
                >
                  {t("submit")}
                </Button>
              ) : (
                <Tooltip
                  title={
                    <h3>
                      {t("you_should_answer_to_all_questions_before_submit")}
                    </h3>
                  }
                >
                  <span>
                    <Button
                      disabled
                      color="secondary"
                      style={{ width: "190px" }}
                      variant="contained"
                    >
                      {t("submit")}
                    </Button>
                  </span>
                </Tooltip>
              )
            ) : (
              <Button
                onClick={handleNext}
                color="secondary"
                style={{ width: isXsMobile ? "50%" : "190px" }}
                variant="contained"
              >
                {t("next")}
              </Button>
            )}
          </div>
        </div>
      ) : (
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            padding: isAuth ? "30px" : "30px 300px",
            height: isAuth ? "calc(100vh - 60px)" : "calc(100vh - 124px)",
            overflow: "auto",
          }}
        >
          <SadAvatar
            label="there is no use case yet !!"
            alt="NO Cases"
          ></SadAvatar>
        </Box>
      )}
    </div>
  );
};

export default MainQuiz;
